import React from 'react';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';

function startButtonText(type, progress) {
  if (type.toLowerCase() === 'lesson') {
    return t('journeys.viewer.start_lesson');
  }

  if (progress.startedAt) {
    return t('journeys.viewer.continue_path');
  }

  return t('journeys.viewer.start_path');
}

const ActionButton = ({ type, urls, isFirstStep, journeyId, progress }) => {
  const onButtonClick = () => {
    if (isFirstStep) {
      request.patchJSON(routes.JOURNEY.START(journeyId));
    }
    window.location.assign(urls.view);
  };
  return (
    <button
      onClick={onButtonClick}
      className="JourneyContentButton"
      type="button"
      data-testid="JourneyContentButton"
    >
      {startButtonText(type, progress)}
    </button>
  );
};

export default ActionButton;
